import type { SVGProps } from 'react';
const SvgVolumeCross = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M10.434 4.1a1.002 1.002 0 0 0-1.059.122L4.65 8H2c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h2.65l4.725 3.781a1.006 1.006 0 0 0 1.059.119A.996.996 0 0 0 11 19V5c0-.384-.222-.734-.566-.9zM2 14v-4h3v4H2zm7 2.919-3-2.4V9.482l3-2.4v9.837zM20.206 9.5l-.706-.706-2.5 2.5-2.5-2.5-.706.706 2.5 2.5-2.5 2.5.706.706 2.5-2.5 2.5 2.5.706-.706-2.5-2.5z" />
  </svg>
);
export default SvgVolumeCross;
